/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign({
      wishlists: 'smart'
  }, window.boostSDAppConfig.integration || {});
  
  // Add analytics tracking configuration
  window.boostSDAppConfig.analytics = Object.assign({
      // Enable all analytics features
      enabled: true,
      // Track product impressions
      trackProductImpressions: true,
      // Track product clicks
      trackProductClicks: true,
      // Track search queries
      trackSearchQueries: true,
      // Track filter usage
      trackFilterUsage: true
  }, window.boostSDAppConfig.analytics || {});
}

// Preserve existing customizations
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  // Existing slider customization
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('RecommendationWidget.Slider', {
          name: 'Change number of products in slider #224858',
          apply: () => ({
              props: (props) => {
                  if (window.innerWidth > 1024) {
                      const hasMoreThanFourProds = props.slides?.length > 4;
                      props.slidesToShow = hasMoreThanFourProds ? 4 : props.slidesToShow;
                      props.hasPagination = hasMoreThanFourProds;
                      props.enableButtons = hasMoreThanFourProds;
                  }
                  if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
                      const hasMoreThanThreeProds = props.slides?.length > 3;
                      props.slidesToShow = hasMoreThanThreeProds ? 3 : props.slidesToShow;
                      props.hasPagination = hasMoreThanThreeProds;
                      props.enableButtons = hasMoreThanThreeProds;
                  }
                  return props;
              },
          }),
      });
  },
  
  // Add analytics tracking for search
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('InstantSearchBox', {
          name: 'Track search queries and interactions',
          apply: () => ({
              methods: {
                  afterSearch: function(searchData, originalMethod) {
                      // Track search query
                      if (window.boostPFS && window.boostPFS.analytics) {
                          window.boostPFS.analytics.trackSearchQuery({
                              searchTerm: searchData.searchTerm,
                              resultCount: searchData.total || 0
                          });
                      }
                      return originalMethod.call(this, searchData);
                  }
              },
              mounted: function(originalMounted) {
                  // Track search box impressions
                  if (window.boostPFS && window.boostPFS.analytics) {
                      window.boostPFS.analytics.trackEvent('search_box_impression');
                  }
                  
                  if (typeof originalMounted === 'function') {
                      return originalMounted.call(this);
                  }
              }
          })
      });
  },
  
  // Add analytics tracking for filter interactions
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('FilterTree', {
          name: 'Track filter interactions',
          apply: () => ({
              methods: {
                  onFilterItemClick: function(filter, originalMethod) {
                      // Track filter selection/removal
                      if (window.boostPFS && window.boostPFS.analytics) {
                          window.boostPFS.analytics.trackFilterUsage({
                              filterName: filter.label,
                              filterValue: filter.value,
                              filterAction: filter.selected ? 'remove' : 'add'
                          });
                      }
                      return originalMethod.call(this, filter);
                  }
              },
              mounted: function(originalMounted) {
                  // Track filter tree impressions
                  if (window.boostPFS && window.boostPFS.analytics) {
                      window.boostPFS.analytics.trackEvent('filter_tree_impression');
                  }
                  
                  if (typeof originalMounted === 'function') {
                      return originalMounted.call(this);
                  }
              }
          })
      });
  },
  
  // Add analytics tracking for product interactions
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('Product', {
          name: 'Track product interactions',
          apply: () => ({
              methods: {
                  onClick: function(event, originalMethod) {
                      // Track product click
                      if (window.boostPFS && window.boostPFS.analytics && this.product) {
                          window.boostPFS.analytics.trackProductClick({
                              productId: this.product.id,
                              productName: this.product.title,
                              productPrice: this.product.price
                          });
                      }
                      
                      if (typeof originalMethod === 'function') {
                          return originalMethod.call(this, event);
                      }
                  }
              },
              mounted: function(originalMounted) {
                  // Set up intersection observer for product impressions
                  if (window.IntersectionObserver && this.product) {
                      const observer = new IntersectionObserver((entries) => {
                          entries.forEach(entry => {
                              if (entry.isIntersecting && window.boostPFS && window.boostPFS.analytics) {
                                  window.boostPFS.analytics.trackProductImpression({
                                      productId: this.product.id,
                                      productName: this.product.title,
                                      productPrice: this.product.price
                                  });
                                  observer.unobserve(entry.target);
                              }
                          });
                      }, { threshold: 0.5 });
                      
                      observer.observe(this.$el);
                  }
                  
                  if (typeof originalMounted === 'function') {
                      return originalMounted.call(this);
                  }
              }
          })
      });
  },
  
  // Add analytics tracking for pagination and sorting
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('Pagination', {
          name: 'Track pagination interactions',
          apply: () => ({
              methods: {
                  onPageClick: function(page, originalMethod) {
                      // Track pagination click
                      if (window.boostPFS && window.boostPFS.analytics) {
                          window.boostPFS.analytics.trackEvent('pagination_click', {
                              page: page
                          });
                      }
                      
                      if (typeof originalMethod === 'function') {
                          return originalMethod.call(this, page);
                      }
                  }
              }
          })
      });
      
      componentRegistry.useComponentPlugin('Sorting', {
          name: 'Track sorting interactions',
          apply: () => ({
              methods: {
                  onSortingChange: function(value, originalMethod) {
                      // Track sorting change
                      if (window.boostPFS && window.boostPFS.analytics) {
                          window.boostPFS.analytics.trackEvent('sorting_change', {
                              sortOption: value
                          });
                      }
                      
                      if (typeof originalMethod === 'function') {
                          return originalMethod.call(this, value);
                      }
                  }
              }
          })
      });
  },
  
  // Add analytics tracking for recommendations
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('RecommendationWidget', {
          name: 'Track recommendation impressions',
          apply: () => ({
              mounted: function(originalMounted) {
                  // Track recommendation impressions
                  if (window.boostPFS && window.boostPFS.analytics && this.title) {
                      window.boostPFS.analytics.trackEvent('recommendation_impression', {
                          title: this.title,
                          products: (this.products || []).map(p => p.id).join(',')
                      });
                  }
                  
                  if (typeof originalMounted === 'function') {
                      return originalMounted.call(this);
                  }
              }
          })
      });
  }
]);

// Global callback for product results rendered
document.addEventListener('boostPFS:afterProductsRendered', function(event) {
  // Track product list impressions
  if (window.boostPFS && window.boostPFS.analytics) {
      const products = event.detail && event.detail.products;
      if (Array.isArray(products)) {
          window.boostPFS.analytics.trackProductListImpression({
              products: products.map(p => ({
                  id: p.id,
                  name: p.title,
                  price: p.price
              }))
          });
      }
  }
});

// Global callback for filter tree rendered
document.addEventListener('boostPFS:afterFilterTreeRendered', function() {
  // Track filter tree impressions
  if (window.boostPFS && window.boostPFS.analytics) {
      window.boostPFS.analytics.trackEvent('filter_tree_rendered');
  }
});